module.exports = __webpack_public_path__ + "media/images/fantastic-3db4c31f2170d1f2daea5b855ad1e2f4.svg";